(function () {
  const initProductRecommendationsSlider = () => {
    // Solo inicializar el slider en mobile (pantallas menores o iguales a 750px)
    if (window.innerWidth > 750) return;

    const container = document.querySelector('[data-recommendations-slider]');
    if (!container) {
      console.log('Product recommendations container not found yet');
      return;
    }

    // Verificar que Swiper esté disponible
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not loaded yet for product recommendations');
      return;
    }

    // Destruir instancia previa si existe
    if (container.swiper) {
      console.log('Destroying previous Swiper instance');
      container.swiper.destroy(true, true);
    }

    const nextEl = container.querySelector('.recommendations__nav--next');
    const prevEl = container.querySelector('.recommendations__nav--prev');

    // Obtener configuración desde atributos data si existen
    const slidesPerView = container.dataset.slidesPerView || 1.2;
    const centeredSlides = container.dataset.centeredSlides !== 'false';

    console.log('Initializing product recommendations slider with config:', {
      slidesPerView: parseFloat(slidesPerView),
      centeredSlides: centeredSlides
    });

    const recommendationsSwiper = new Swiper('[data-recommendations-slider]', {
      slidesPerView: parseFloat(slidesPerView),
      spaceBetween: 3,
      loop: true,
      centeredSlides: centeredSlides,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      },
      on: {
        init: function() {
          console.log('Product recommendations slider initialized successfully');
        }
      }
    });
  };

  // Escuchar el evento personalizado que dispara el custom element
  document.addEventListener('product-recommendations:loaded', () => {
    console.log('Product recommendations loaded event received');
    // Esperar un momento para que el DOM se haya renderizado completamente
    setTimeout(initProductRecommendationsSlider, 100);
  });

  // Fallback: Initialize on page load por si las recomendaciones ya están cargadas
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // Esperar un poco más en DOMContentLoaded para asegurar que Swiper esté disponible
      setTimeout(initProductRecommendationsSlider, 300);
    });
  } else {
    // Si el DOM ya está listo
    setTimeout(initProductRecommendationsSlider, 300);
  }

  // Re-initialize when window is resized (para cambios de orientación en mobile)
  // let resizeTimer;
  // window.addEventListener('resize', () => {
  //   clearTimeout(resizeTimer);
  //   resizeTimer = setTimeout(() => {
  //     initProductRecommendationsSlider();
  //   }, 250);
  // });

  // Re-initialize after Shopify section updates
  // document.addEventListener('shopify:section:load', () => {
  //   console.log('Shopify section loaded');
  //   setTimeout(initProductRecommendationsSlider, 100);
  // });
})();
